import { Container, Paper, Text, Button, Group, Stack } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

export const LogoutPage = () => {
  const navigate = useNavigate();

  return (
    <Container size="sm" mt="xl">
      <Paper shadow="sm" p="xl" radius="md" withBorder>
        <Stack align="center" gap="lg">
          <IconCheck size={48} color="green" />
          <Text size="xl" fw={600} ta="center">
            You've been signed out
          </Text>
          <Text size="md" c="dimmed" ta="center">
            You have successfully signed out of the Licence Management Portal.
          </Text>
          <Group justify="center" mt="md">
            <Button onClick={() => navigate('/')}>
              Sign Back In
            </Button>
          </Group>
        </Stack>
      </Paper>
    </Container>
  );
};
